import axios from 'axios';
import store from '../../redux/store';
import systemSlice from '../../redux/systemSlice';
import checkOTP from './checkOTP';

const handleRequest = async (props: { method: "post" | "get" | "patch", url: string, data?: any, headers?: any, params?: any, showPreLoader: boolean, isCreateNewApp?: { duration: number, animationText?: string }, createActionProps?: any }) => {
    const { method, url, data, headers, params, showPreLoader, isCreateNewApp, createActionProps } = props
    const responseData: { error: boolean, result: any, errorType: string } = { error: false, result: {}, errorType: "" };
    isCreateNewApp && store.dispatch(systemSlice.actions.isLottiePreloader({ animationText: isCreateNewApp?.animationText }));
    if (!isCreateNewApp) store.dispatch(systemSlice.actions.isLottiePreloader(null));
    showPreLoader && store.dispatch(systemSlice.actions.setIsShow(true));
    try {
        if (!isCreateNewApp) {
            const response = await axios({
                method,
                url: url,
                data: data,
                headers: headers,
                params: params
            })
            responseData.result = response.data;
            responseData.error = false;
        } else {
            //wait 1000 sec
            //burayı asım yazmış
            await new Promise(resolve => setTimeout(resolve, isCreateNewApp?.duration || 4000));
            const response = await axios({
                method,
                url: url,
                data: data,
                headers: headers,
            })
            responseData.result = response.data;
            responseData.error = false;
        }

    } catch (error: any) {
        responseData.result = error.response;
        responseData.error = true;
    }

    showPreLoader && store.dispatch(systemSlice.actions.setIsShow(false));
    return checkOTP({ responseData, createActionProps });

};

export default handleRequest;


